module.exports = __webpack_public_path__ + "img/arrow-with-circle.b5c6f08d.svg";